import { useCallback, useEffect, useRef, useState } from "react";
export function useDebouncedFieldUpdate({ value, onCommit, delay = 500 }) {
    const [local, setLocal] = useState(value);
    const timer = useRef(null);
    const onCommitRef = useRef(onCommit);
    onCommitRef.current = onCommit;
    const localRef = useRef(local);
    localRef.current = local;
    const initialValueRef = useRef(value);
    useEffect(function syncLocalValueFromProp() {
        if (initialValueRef.current !== value) {
            initialValueRef.current = value;
            setLocal(value);
        }
    }, [
        value
    ]);
    const onChange = useCallback((next)=>{
        setLocal(next);
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(()=>{
            timer.current = null;
            onCommitRef.current(next);
        }, delay);
    }, [
        delay
    ]);
    const flush = useCallback(()=>{
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
            onCommitRef.current(localRef.current);
        }
    }, []);
    // Unmount must flush, not drop: a keyed remount (e.g. the step panel
    // retargeting to another step) tears this instance down mid-debounce, and a
    // bare clearTimeout would silently discard the edit. The refs still hold this
    // instance's handler and value at cleanup time, so the commit lands on the
    // right target. StrictMode-safe: no timer is pending on the simulated
    // unmount that immediately follows mount.
    useEffect(function flushPendingCommitOnUnmount() {
        return ()=>{
            if (timer.current) {
                clearTimeout(timer.current);
                timer.current = null;
                onCommitRef.current(localRef.current);
            }
        };
    }, []);
    return {
        value: local,
        onChange,
        flush
    };
}

//# sourceMappingURL=useDebouncedFieldUpdate.js.map